import styled from 'styled-components';

export const StyledPaginationTable = styled.div`
  .ant-table-cell {
    text-align: center !important;
    vertical-align: middle !important;
  }

  .pagination-table-total {
    padding: 14px 16px;
    background: #f8f8f8;
    border-top: 1px solid #cfcfcf;

    > p {
      font-size: 18px;
      font-weight: 500;
      line-height: 21.48px;
      color: #353535;

      > span {
        font-size: 18px;
        font-weight: 500;
        line-height: 21.48px;
        color: #415f9d;
      }
    }
  }

  .ant-row {
    /* display: none !important; */
    border-bottom: none;
  }

  .ant-table-wrapper {
    border-top: 1px solid #cfcfcf;

    .ant-table-thead {
      border-bottom: 1px solid #cfcfcf;

      .ant-table-cell {
        height: auto;
        font-size: 16px;
        font-weight: 500;
        line-height: 19.09px;
        color: #353535;
        border-bottom: 1px solid #cfcfcf;

        &::before {
          display: none !important;
        }

        &:first-of-type {
          border-start-start-radius: 0px !important;
        }

        &:last-child {
          border-start-end-radius: 0px !important;
        }
      }
    }

    .ant-table-tbody {
      .ant-table-row {
        &:nth-child(odd) {
          //border-bottom: 1px solid #cfcfcf;
        }

        .ant-table-cell {
          height: 60px;
          font-size: 16px;
          font-weight: 500;
          line-height: 19.09px;
          color: #353535;
          border-bottom: 1px solid #cfcfcf;
        }
      }

      .ant-table-placeholder {
        height: 50px !important;
        border-bottom: 1px solid #cfcfcf;

        > .ant-table-cell {
          border-bottom: 1px solid #cfcfcf;
        }
      }
    }
  }

  .table-pagination {
    padding: 15px 0px 0px;
    text-align: center;

    ul {
      display: inline-flex;

      li {
        font-weight: 700;
        font-size: 16px;

        width: 24px;
        height: 24px;

        display: flex;
        align-items: center;
        justify-content: center;

        &.ant-pagination-prev,
        &.ant-pagination-next {
          button {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        &.ant-pagination-disabled {
          cursor: not-allowed;
          path {
            fill: #8b8e93;
          }
        }

        .ant-pagination-item-link {
          display: flex;
          align-items: center;
        }
        a {
          width: 100%;
          height: 100%;
          color: #8b8e93;
          line-height: 1.3;
        }

        &.ant-pagination-item-active {
          border: 1px solid #fff;

          a {
            color: #000;
          }
        }
      }
    }
  }
`;
